import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../../framework/components/FullPageSpinner/FullPageSpinner';
import { spinnerOpen } from '../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { closeWebview } from './ClosePageUtils';
import { PpcCloseEvent } from './ClosePageConstants';

export class ClosePage extends Component {
    static propTypes = {
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    getPpcCloseEvent() {
        const ppcCloseEvent = new URLSearchParams(window.location.search).get('event');
        
        // Fallback to COMPLETE if invalid event in URL.
        const isValidPpcCloseEvent = Object.values(PpcCloseEvent).includes(ppcCloseEvent);
        if (!isValidPpcCloseEvent) {
            return PpcCloseEvent.COMPLETE;
        }

        return ppcCloseEvent;
    }

    componentDidMount() {
        this.props.onComponentDidMount();

        const ppcCloseEvent = this.getPpcCloseEvent();
        closeWebview(ppcCloseEvent);
    }

    render() {
        return <div />;
    }
}

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(spinnerOpen());
    }
});

export default connect(
    null,
    mapDispatchToProps
)(ClosePage);
